import ReactOnRails from 'react-on-rails/client';
import TeamsCommitteesCouncils from '../../app/TeamsCommitteesCouncils.jsx';

ReactOnRails.register({TeamsCommitteesCouncils});